module.exports = __webpack_public_path__ + "assets/header-homepage-2025-bg-decoration.3fa1c4a6.png";